import { useQuery } from '@tanstack/react-query'
import { toast } from 'sonner'
import { internal_backend } from '~/internal-backend'

export const GET_SHOPIFY_PRODUCTS_QUERY_KEY = 'get-shopify-products'

export const useGetShopifyProducts = () => {
  return useQuery({
    queryKey: [GET_SHOPIFY_PRODUCTS_QUERY_KEY],
    queryFn: async () => {
      const response = await internal_backend.get_products.request()
      const parsed = internal_backend.get_products.responseSchema.safeParse(response)
      if (!parsed.success) {
        console.error(parsed.error)
        toast.error('Failed to parse Shopify products')
        return []
      }
      return parsed.data.products.edges.map((edge) => edge.node)
    },
    refetchOnWindowFocus: false,
  })
}
